import gql from 'graphql-tag'

export const GET_MATERIAL_LIST = gql`
  query GetMaterials {
    materials {
      id
      category {
        id
        name
      }
      name
      cover {
        id
        url
      }
      baseMaterial
      CO2
      circularBin
      commonName
      unit
      images {
        id
        uid
        url
      }
      viewCount
      advance
    }
    categories {
      id
      name
    }
    options: __type(name: "Unit") {
      units: enumValues {
        name
      }
    }
  }
`

export const GET_MATERIAL_BY_ID = gql`
  query GetMaterialById($id: Int!) {
    material(id: $id) {
      id
      category {
        id
        name
      }
      name
      cover {
        id
        name
        url
      }
      baseMaterial
      CO2
      circularBin
      commonName
      unit
      images {
        id
        uid
        url
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/Material.js